export const mergeDriverDayLocked = (
  { matrixDays },
  { dayOfWeek, driverCode, lockedByUserCode, lockedByUserName, lockedDatetime }
) => {
  const { [dayOfWeek]: day, ...restOfWeek } = matrixDays;
  const newMatrixDays = {
    ...restOfWeek,
    [dayOfWeek]: {
      ...day,
      driverDayLocks: {
        ...day.driverDayLocks,
        [driverCode]: {
          checksum: matrixDays[dayOfWeek].driverDayLocks[driverCode].checksum,
          lockedByUserCode,
          lockedByUserName,
          lockedDatetime,
          lockedByYou: true,
          lockedInDifferentBrowser: false,
        },
      },
    },
  };
  return newMatrixDays;
};

export const mergeDriverDayUnlocked = (
  { matrixDays },
  { dayOfWeek, driverCode }
) => {
  const { [dayOfWeek]: day, ...restOfWeek } = matrixDays;
  const newMatrixDays = {
    ...restOfWeek,
    [dayOfWeek]: {
      ...day,
      driverDayLocks: {
        ...day.driverDayLocks,
        [driverCode]: {
          checksum: matrixDays[dayOfWeek].driverDayLocks[driverCode].checksum,
          lockedByUserCode: null,
          lockedByUserName: null,
          lockedDatetime: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        },
      },
    },
  };
  return newMatrixDays;
};

export const mergeRouteDayLocked = (
  { matrixDays },
  { dayOfWeek, routeCode, lockedByUserCode, lockedByUserName, lockedDatetime }
) => {
  const { [dayOfWeek]: day, ...restOfWeek } = matrixDays;
  const newMatrixDays = {
    ...restOfWeek,
    [dayOfWeek]: {
      ...day,
      routeDayLocks: {
        ...day.routeDayLocks,
        [routeCode]: {
          checksum: matrixDays[dayOfWeek].routeDayLocks[routeCode].checksum,
          lockedByUserCode,
          lockedByUserName,
          lockedDatetime,
          lockedByYou: true,
          lockedInDifferentBrowser: false,
        },
      },
    },
  };
  return newMatrixDays;
};

export const mergeRouteDayUnlocked = (
  { matrixDays },
  { dayOfWeek, routeCode }
) => {
  const { [dayOfWeek]: day, ...restOfWeek } = matrixDays;
  const newMatrixDays = {
    ...restOfWeek,
    [dayOfWeek]: {
      ...day,
      routeDayLocks: {
        ...day.routeDayLocks,
        [routeCode]: {
          checksum: matrixDays[dayOfWeek].routeDayLocks[routeCode].checksum,
          lockedByUserCode: null,
          lockedByUserName: null,
          lockedDatetime: null,
          lockedByYou: false,
          lockedInDifferentBrowser: false,
        },
      },
    },
  };
  return newMatrixDays;
};
